module.exports = __webpack_public_path__ + "static/media/settings.ea81934c.svg";